import { render, staticRenderFns } from "./ProductShippingPromo.vue?vue&type=template&id=36c7f5a0&"
import script from "./ProductShippingPromo.vue?vue&type=script&lang=js&"
export * from "./ProductShippingPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports